import React, { useState } from "react";
import SearchBar from "../../components/SearchBar";
import Navbar from "../../components/Navbar";
import hamburger_icon from "../../assets/icons/hamburger_icon.png";
import processing_Time_image from "../../assets/images/processing_Time_image.png";
import processing_efficiency_graph_image from "../../assets/images/processing_efficiency_graph_image.png";

const AdminServerProcessing = () => {
  const [isNavbarVisible, setIsNavbarVisible] = useState(false);
  const toggleNavbar = () => {
    setIsNavbarVisible(!isNavbarVisible);
  };
  return (
    <div>
      <div className="flex items-center justify-center w-full">
        <div
          className="items-center justify-center hidden hamburger"
          onClick={toggleNavbar}
        >
          <img
            src={hamburger_icon}
            className="object-contain"
            alt="hamburger"
          />
        </div>
        <div className="flex items-center justify-center w-full">
          <SearchBar categoryName="Server Processing Time" />
        </div>
        <div className="absolute top-0 w-[70%] z-20 bg-white rounded-lg mt-16">
          {isNavbarVisible && <Navbar />}
        </div>
      </div>

      <div className="ml-4 mt-6">
        <img
          src={processing_efficiency_graph_image}
          alt="processing_efficiency_graph_image"
        />
        <img
          src={processing_Time_image}
          alt="processing_Time_image"
          className="mt-4"
        />
      </div>
    </div>
  );
};

export default AdminServerProcessing;
